import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * PE forms [Archived]
   */
  {
    label:
      'Do you ever have a problem ejaculating sooner than you or your partner would like?',
    field: 'pe1',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    label: "How's your lasting time during a sexual interaction?",
    field: 'pe2-new',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less1min', value: 'Less than 1 minute' },
        { key: '1-3min', value: '1-3 minutes' },
        { key: '4-6min', value: '4-6 minutes' },
        { key: '7-9min', value: '7-9 minutes' },
        { key: '10min', value: '10+ minutes' }
      ]
    }
  },
  {
    label: 'How long would you like to last during a sexual interaction?',
    field: 'pe3-new',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1-3min', value: '1-3 minutes' },
        { key: '4-6min', value: '4-6 minutes' },
        { key: '7-8min', value: '7-9 minutes' },
        { key: '10min', value: '10+ minutes' }
      ]
    }
  },
  {
    label:
      'Which option best describes the average duration of time before you normally ejaculate?',
    field: 'pe2',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1to3', value: '1 - 3 Mins' },
        { key: '5to10', value: '5 - 10 Mins' },
        { key: '10more', value: '10 Mins or more' }
      ],
      fullWidth: true
    }
  },
  {
    label: 'How did your premature ejaculation start?',
    field: 'pe3',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'opt1',
          value: 'I have dealt with it as long as I have been sexually active'
        },
        { key: 'opt2', value: 'Suddenly with a new partner' },
        { key: 'opt3', value: 'Suddenly but not with a new partner' },
        { key: 'opt4', value: 'Gradually, but has worsened over time' },
        { key: 'opt5', value: 'I do not recall how it started' }
      ],
      fullWidth: true
    }
  },
  {
    label:
      'Do you have any Erectile Dysfunction (problems obtaining or maintaining an erection until ejaculation)',
    field: 'pe4',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'radio',
            name: 'treatment1',
            label: 'Have you sought treatment for this?',
            options: [
              { key: 'no', value: 'No' },
              {
                key: 'yes',
                value: 'Yes',
                answer: {
                  type: 'radio',
                  name: 'treatment2',
                  label: 'Have you sought treatment for this?',
                  options: [
                    {
                      key: 'opt1',
                      value:
                        'I am currently taking medication such as Viagra (Sildenafil), Cialis (Tadalafil)'
                    },
                    {
                      key: 'opt2',
                      value:
                        'I have taken Viagra (Sildenafil) or Cialis (Tadalafil) in the past'
                    },
                    {
                      key: 'opt3',
                      value: 'other',
                      answer: {
                        type: 'text',
                        name: 'other'
                      }
                    }
                  ]
                }
              }
            ]
          }
        },
        { key: 'no', value: 'No' }
      ],
      fullWidth: true
    },
    fullWidth: true
  },
  {
    label:
      'Have you ever tried to manage your premature ejaculation (PE) before?',
    field: 'pe5',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yesTopical',
          value: 'Yes – using topical treatments (such as numbing creams)'
        },
        {
          key: 'yesOther',
          value: 'Yes – using other types of treatment',
          answer: {
            type: 'text',
            name: 'yesOtherDesc',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ],
      fullWidth: true
    }
  },
  {
    field: 'pe6-new',
    label: 'How many times/month are you sexually active?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'monthlyActivity'
    }
  },
  {
    field: 'pe7-new',
    label:
      'If you were not hindered by ED, how many times/month would you want to be sexually active?',
    type: 'info',
    answer: {
      type: 'number',
      name: 'wantedMonthlyActivity'
    }
  },
  {
    label: 'Is there anything else you would like the doctor to know?',
    field: 'pe6',
    type: 'info',
    answer: {
      type: 'text',
      placeholder: 'Please describe'
    }
  },
  {
    field: 'peAcknowledgement',
    label:
      'I agree to have my relevant prescription information transferred to IHS Compounding Pharmacy. The information shared will be kept strictly confidential according to Ontario college of Pharmacy’s regulations.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [{ key: 'peAcknowledgement', value: 'I Agree' }]
    }
  }
];

export default questionsModels;
